import { createIcon } from './create-icon';

export const BoltIcon = createIcon('BoltIcon', <path d="M13 2L4 13h7l-1 9 9-11h-7l1-9z" />);
